// Б.3 → C.1: Раст active (v6) — «1 раз за матч скопируй любой Мод с одного
// своего юнита на другого. Исходный Мод остаётся на источнике, на цели
// появляется копия».
//
// v6 dsl_active: target=ally_choose, effect=copy_mod_between_allies, uses=1.
//
// Цель: ДВА своих юнита — источник (с Модом) и приёмник (любой другой свой).
// Если на источнике несколько Модов — копируется первый (для прогона карт
// этого достаточно; выбор конкретного Мода — отдельная доработка).
//
// До C.1 здесь была старая способность «+0/3/0 + Провокация» — заменена (БУГ.19).

import { attachMod } from './modifications.js';

export const HERO_ID = 'syn_rast';

// Кандидаты-ИСТОЧНИКИ: свои живые юниты, у которых есть хотя бы один Мод.
export function getRastActiveTargets(state, playerIdx) {
  return state.players[playerIdx].unitsOnField()
    .filter(u => Array.isArray(u.modifications) && u.modifications.length > 0);
}

export function rastActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  // Нужен источник с Модом И ещё хотя бы один юнит-приёмник.
  if (getRastActiveTargets(state, playerIdx).length === 0) return false;
  if (p.unitsOnField().length < 2) return false;
  return true;
}

// sourceCard — свой юнит с Модом; destCard — другой свой юнит.
// Возвращает {ok} либо {ok:false, reason}.
export function rastActive(state, playerIdx, sourceCard, destCard) {
  if (!rastActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  const me = state.players[playerIdx];
  for (const c of [sourceCard, destCard]) {
    if (!c || c.type !== 'unit' || !c.isAlive()) {
      return { ok: false, reason: 'invalid_target' };
    }
    if (c.ownerId !== me.id || !me.unitsOnField().includes(c)) {
      return { ok: false, reason: 'not_ally' };
    }
  }
  if (sourceCard === destCard) {
    return { ok: false, reason: 'same_unit' };
  }
  if (!Array.isArray(sourceCard.modifications) || sourceCard.modifications.length === 0) {
    return { ok: false, reason: 'source_has_no_mod' };
  }
  // Копируем первый Мод источника на приёмник (исходный остаётся).
  const srcMod = sourceCard.modifications[0];
  const r = attachMod(state, destCard, { id: srcMod.id, name_ru: srcMod.name_ru }, {
    heroId: HERO_ID, ownerIdx: playerIdx
  });
  if (!r || r.ok === false) {
    return { ok: false, reason: (r && r.reason) || 'attach_failed' };
  }
  state.log.add(
    `✨ Раст [${me.name}] [active]: Мод «${srcMod.name_ru}» скопирован ` +
    `${sourceCard.name_ru} → ${destCard.name_ru}`
  );
  me.heroActiveUsed = true;
  return { ok: true };
}
